import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export default class UserCreditCard {
  @IsNumber()
  @Expose()
  creditCardId!: number;
  @IsString()
  @Expose()
  creditCardName!: string;
  @IsString()
  @Expose()
  creditCardNumber!: string;
  @IsString()
  @Expose()
  creditCardCurrency!: string;
  @IsBoolean()
  @Expose()
  isAssigned!: boolean;
  @IsBoolean()
  @Expose()
  isDefault!: boolean;
}

export class UserCreditCardResponse extends GenericTableResponse<UserCreditCard> {
  @Type(() => UserCreditCard)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<UserCreditCard>;
}
